const routerView = {
  template: '<router-view></router-view>'
};
export const ConsultDesk = [
  {
    name: 'operation',
    path: '/operation',
    meta: {
      title: '채팅 상담 데스크',
      parentKey: 'OPERATION_MENU'
    },
    component: () => import('@/components/operation/operation_board') // 상담 데스크
  },
  {
    name: 'Call Operation',
    path: '/call/operation',
    meta: {
      title: '콜 상담 데스크',
      parentKey: 'CALL_OPERATION_MENU'
    },
    component: () => import(/* webpackChunkName: "callOperation" */ '@/views/callOperation/Index') // 콜 상담 데스크
  },
  {
    name: 'inquiry_desk',
    path: '/inquiry_desk',
    meta: {
      title: '문의 게시판',
      parentKey: 'INQUIRY_DESK_MENU'
    },
    component: () => import(/* webpackChunkName: "InquiryDesk" */ '@/views/inquiryDesk/InquiryDesk') // 문의 게시판
  },
  {
    name: 'contact_support_desk',
    path: '/contact_support_desk',
    meta: {
      title: '1:1 문의 내역',
      parentKey: 'CONTACT_SUPPORT_MENU'
    },
    component: () => import(/* webpackChunkName: "ContactSupportDesk" */ '@/views/contactSupportDesk/Index') // 1:1 문의 내역
  },
  {
    name: 'ticketDep',
    path: '',
    meta: {
      title: '티켓'
    },
    component: routerView,
    children: [
      {
        name: 'my_ticket',
        path: '/ticket/my_ticket',
        meta: {
          title: '나에게 할당된 티켓',
          parentKey: 'TICKET_MENU'
        },
        component: () => import(/* webpackChunkName: "MyTicket" */ '@/views/workplace/counselAnalysis/ticket/MyTicket') // 티켓 -> 나에게 할당된 티켓
      },
      {
        name: 'voc_my_ticket',
        path: '/voc_ticket/my_ticket',
        meta: {
          title: '나의 VOC 티켓',
          parentKey: 'TICKET_MENU'
        },
        component: () => import(/* webpackChunkName: "VOCMyTicket" */ '@/views/workplace/counselAnalysis/ticket/VOCMyTicket') // 티켓 -> 나에게 할당된 티켓
      },
      {
        name: 'ticket_create',
        path: '/ticket/ticket_create',
        meta: {
          title: '신규 티켓 추가',
          parentKey: 'TICKET_MENU'
        },
        component: () => import(/* webpackChunkName: "TicketMyCreate" */ '@/views/workplace/counselAnalysis/ticket/TicketCreate') // 티켓 -> 나에게 할당된 티켓 -> 신규 티켓 추가
      },
      {
        name: 'voc_ticket_create',
        path: '/voc_ticket/ticket_create',
        meta: {
          title: 'VOC 신규 티켓 추가',
          parentKey: 'TICKET_MENU'
        },
        component: () => import(/* webpackChunkName: "VOCTicketMyCreate" */ '@/views/workplace/counselAnalysis/ticket/VOCTicketCreate') // 티켓 -> 나의 VOC 티켓 -> VOC 신규 티켓 추가
      },
      {
        name: 'voc_ticket_list_create',
        path: '/voc_ticket/list/ticket_create',
        meta: {
          title: 'VOC 신규 티켓 추가',
          parentKey: 'TICKET_MENU'
        },
        component: () => import(/* webpackChunkName: "VOCTicketMyCreate" */ '@/views/workplace/counselAnalysis/ticket/VOCTicketCreate') // 티켓 -> 전체 VOC 티켓 -> VOC 신규 티켓 추가
      },
      {
        name: 'ticket_details',
        path: '/ticket/ticket_details',
        meta: {
          title: '티켓 상세',
          parentKey: 'TICKET_MENU'
        },
        component: () => import(/* webpackChunkName: "TicketMyDetails" */ '@/views/workplace/counselAnalysis/ticket/TicketDetails') // 티켓 -> 나에게 할당된 티켓 -> 티켓 상세
      },
      {
        name: 'voc_ticket_details',
        path: '/voc_ticket/ticket_details',
        meta: {
          title: 'VOC 티켓 상세',
          parentKey: 'TICKET_MENU'
        },
        component: () => import(/* webpackChunkName: "VOCTicketMyDetails" */ '@/views/workplace/counselAnalysis/ticket/VOCTicketDetails') // 티켓 -> 나의 VOC 티켓 / 전체 VOC 티켓 -> VOC 티켓 상세
      },
      {
        name: 'ticket_list',
        path: '/ticket/list',
        meta: {
          title: '전체 티켓',
          parentKey: 'TICKET_MENU'
        },
        component: () => import(/* webpackChunkName: "TicketList" */ '@/views/workplace/counselAnalysis/ticket/TicketList') // 티켓 -> 전체 티켓
      },
      {
        name: 'erp_ticket_list',
        path: '/ticket/erp_ticket',
        meta: {
          title: 'AI 콜봇 티켓',
          parentKey: 'TICKET_MENU'
        },
        component: () => import(/* webpackChunkName: "ERPTicketList" */ '@/views/workplace/counselAnalysis/ticket/ERPTicketList') // 티켓 -> AI 콜봇 티켓
      },
      {
        name: 'erp_ticket_list_details',
        path: '/ticket/erp_ticket/ticket_details',
        meta: {
          title: 'AI 콜봇 티켓 상세',
          parentKey: 'TICKET_MENU'
        },
        props: (route) => ({
          ticketId: route.query.ticketId || route.params.ticketId || '',
          listItem: route.params.listItem || null,
          detailData: route.params.detailData || null
        }),
        component: () => import(/* webpackChunkName: "ERPTicketSaved" */ '@/views/workplace/counselAnalysis/ticket/ERPTicketSaved') // 티켓 -> AI 콜봇 티켓 -> 티켓 상세(ERP 저장)
      },
      {
        name: 'voc_ticket_list',
        path: '/voc_ticket/list',
        meta: {
          title: '전체 VOC 티켓',
          parentKey: 'TICKET_MENU'
        },
        component: () => import(/* webpackChunkName: "VOCTicketList" */ '@/views/workplace/counselAnalysis/ticket/VOCTicketList') // 티켓 -> 전체 VOC 티켓
      },
      {
        name: 'ticket_list_create',
        path: '/ticket/list/ticket_create',
        meta: {
          title: '신규 티켓 추가',
          parentKey: 'TICKET_MENU'
        },
        component: () => import(/* webpackChunkName: "TicketAllCreate" */ '@/views/workplace/counselAnalysis/ticket/TicketCreate') // 티켓 -> 전체 티켓 -> 신규 티켓 추가
      },
      {
        name: 'ticket_list_details',
        path: '/ticket/list/ticket_details',
        meta: {
          title: '티켓 상세',
          parentKey: 'TICKET_MENU'
        },
        component: () => import(/* webpackChunkName: "TicketAllDetails" */ '@/views/workplace/counselAnalysis/ticket/TicketDetails') // 티켓 -> 전체 티켓 -> 티켓 상세
      },
      {
        name: 'voc_ticket_list_details',
        path: '/voc_ticket/list/ticket_details',
        meta: {
          title: 'VOC 티켓 상세',
          parentKey: 'TICKET_MENU'
        },
        component: () => import(/* webpackChunkName: "VocTicketAllDetails" */ '@/views/workplace/counselAnalysis/ticket/VOCTicketDetails') // 티켓 -> 나의 VOC 티켓 / 전체 VOC 티켓 -> VOC 티켓 상세
      },
      {
        name: 'ticket_reopen_chat',
        path: '/ticket/reopen/chat',
        meta: {
          title: '채팅 재인입 화면',
          requiresAuth: false
        },
        props: (route) => ({
          ticketId: route.query.ticketId
        }),
        component: () => import(/* webpackChunkName: "TicketReopenChat" */ '../../components/menus/ticket/ticket_reopen_chat') // 티켓 -> 채팅 재인입 화면
      },
      {
        name: 'video',
        path: '/video',
        meta: {
          title: '상담창 영상 첨부',
          requiresAuth: false
        },
        props: (route) => ({
          videoSource: route.query.videoSource
        }),
        component: () => import(/* webpackChunkName: "videoPlayer" */ '@/components/videoPlayer') // 상담창 영상 첨부
      },
      {
        name: 'order_ticket',
        path: '/ticket/order_ticket',
        meta: {
          title: '발주티켓',
          parentKey: 'TICKET_MENU'
        },
        component: () => import(/* webpackChunkName: "OrderTicketList" */ '@/views/workplace/counselAnalysis/ticket/OrderTicket') // 티켓 -> 발주티켓
      },
      {
        name: 'order_ticket_details',
        path: '/ticket/order_ticket_details',
        meta: {
          title: '발주티켓 상세',
          parentKey: 'TICKET_MENU'
        },
        component: () => import(/* webpackChunkName: "OrderTicketDetails" */ '@/views/workplace/counselAnalysis/ticket/OrderTicketDetails') // 티켓 -> 발주티켓 상세
      }
    ]
  },
  {
    name: 'messagee',
    path: '',
    meta: {
      title: '메시지'
    },
    component: routerView,
    children: [
      {
        name: 'SendMessage',
        path: '/message/send_message',
        meta: {
          title: '메시지 발송',
          parentKey: 'MESSAGE_MENU'
        },
        component: () => import(/* webpackChunkName: "SendMessage" */ '@/views/message/SendMessage') // 메시지 -> 메시지 -> 메시지 발송
      },
      {
        name: 'MessageTemplateManagement',
        path: '/message/message_template_management',
        meta: {
          title: '메시지 템플릿',
          parentKey: 'MESSAGE_MENU'
        },
        component: () => import(/* webpackChunkName: "MessageTemplateManagement" */ '@/views/message/MessageTemplateManagement') // 메시지 -> 메시지 -> 메시지 템플릿
      },
      {
        name: 'SendHistory',
        path: '/message/send_history',
        meta: {
          title: '메시지 발송 내역',
          parentKey: 'MESSAGE_MENU'
        },
        component: () => import(/* webpackChunkName: "SendHistory" */ '@/views/message/SendHistory') // 메시지 -> 메시지 -> 메시지 발송 내역
      },
      {
        name: 'SendMailHistory',
        path: '/message/mail_send_history',
        meta: {
          title: '메일 발송 내역',
          parentKey: 'MESSAGE_MENU'
        },
        component: () => import(/* webpackChunkName: "SendMailHistory" */ '@/views/message/SendMailHistory') // 메시지 -> 메시지 -> 메시지 발송 내역
      },
      {
        name: 'SendMail',
        path: '/message/mail_send',
        meta: {
          title: '메일 발송',
          parentKey: 'MESSAGE_MENU'
        },
        component: () => import(/* webpackChunkName: "SendMail" */ '@/views/message/SendMail') // 메시지 -> 메시지 -> 메시지 발송 내역
      }
    ]
  },
  {
    name: 'consultation',
    path: '/consultation',
    meta: {
      title: '1:1 문의게시판',
      parentKey: 'CUSTOM_MENU'
    },
    component: () => import(/* webpackChunkName: "CustomInquiryDesk" */ '@/views/custom/customInquiryDesk') // 1:1 문의 게시판
  }
];

export const Icomsys = [
  {
    name: 'icomsys_video_counseling',
    path: '/icomsys/video_counseling',
    meta: {
      title: '영상상담'
    },
    component: () => import('@/components/menus/icomsys/video_counseling') // 영상상담
  },
  {
    name: 'icomsys_category_management',
    path: '/icomsys/category_management',
    meta: {
      title: '상담이력 조회'
    },
    component: () => import('@/components/menus/icomsys/category_management') // 상담이력 조회
  },
  {
    name: 'icomsys_fetch_counseling_list',
    path: '/icomsys/fetch_counseling_list',
    meta: {
      title: '카테고리 관리'
    },
    component: () => import('@/components/menus/icomsys/fetch_counseling_list') // 카테고리 관리
  },
  {
    name: 'icomsys_counseling_statistics',
    path: '/icomsys/counseling_statistics',
    meta: {
      title: '영상상담 통계'
    },
    component: () => import('@/components/menus/icomsys/counseling_statistics') // 영상상담 통계
  }
];



// WEBPACK FOOTER //
// ./src/router/subRoutes/consultDesk.js